var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M0.956 19.075L19.944 19.075 19.944 1.288 0.956 1.288z",
    transform: "translate(.036 .768)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M.957 21.363v-9.081h2.447v6.61c0 1.364-1.096 2.47-2.447 2.47M19.944 21.363v-9.081h-2.447v6.61c0 1.364 1.095 2.47 2.447 2.47M.957 12.282c2.936 0 4.3-6.093 4.3-6.093s5.194-1.683 5.194-4.843H.957v10.936z",
    transform: "translate(.036 .768)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M19.944 12.282c-2.937 0-4.301-6.093-4.301-6.093S10.45 4.506 10.45 1.346h9.494v10.936z",
    transform: "translate(.036 .768)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M3.258 12.908H.792c-.342 0-.619-.28-.619-.626 0-.345.277-.625.62-.625h2.465c.342 0 .619.28.619.625 0 .346-.277.626-.62.626M17.643 12.908h2.465c.342 0 .62-.28.62-.626 0-.345-.278-.625-.62-.625h-2.465c-.343 0-.62.28-.62.625 0 .346.277.626.62.626M20.18 1.914H.72c-.343 0-.62-.28-.62-.626C.1.943.377.663.72.663h19.46c.343 0 .62.28.62.625 0 .346-.277.626-.62.626",
    transform: "translate(.036 .768)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShows);
export default __webpack_public_path__ + "static/media/shows.83e677c45dea298bc07ae468de2564d1.svg";
export { ForwardRef as ReactComponent };